import * as React from "react";
const SvgFiRrKnifeKitchen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22.941 2.065c-.688-.69-1.532-1.056-2.443-1.056-.742 0-1.88.256-3.089 1.468L1.035 18.697c-.335.424-.677.866-.838 1.215a2.13 2.13 0 0 0 .151 2.06 2.23 2.23 0 0 0 1.877 1.027c.24.004.47-.004.651-.012 4.16-.166 7.814-1.625 10.294-4.115l2.106-2.144.846.849c.47.47 1.198.559 1.773.213a1.4 1.4 0 0 0 .628-1.638c-.7-2.262-.77-3.695.793-5.26l3.625-3.697a3.64 3.64 0 0 0 0-5.13m-11.193 15.4c-2.087 2.096-5.35 3.38-8.953 3.523a18 18 0 0 1-.566.01c-.119-.04-.183-.084-.199-.11-.047-.072-.026-.118-.017-.137q.082-.171.59-.812c.035-.044 7.985-7.918 7.985-7.918l3.277 3.29zM21.52 5.789l-3.624 3.696c-1.769 1.768-2.016 3.575-1.766 5.266l-4.119-4.135 6.808-6.722c.578-.58 1.158-.886 1.68-.886.372 0 .717.157 1.025.467a1.64 1.64 0 0 1-.005 2.313z"
    />
  </svg>
);
export default SvgFiRrKnifeKitchen;
